import gql from 'graphql-tag'

export default gql`
query getListStorageRelation($language: Language!) {
	cashAssist {
		getListStorageRelation(language: $language) {
            id
            name
	      }
	}
}
`
